import { useState } from 'react';
import PropTypes from 'prop-types';

const ContactInformation = ({ employee, onUpdate, loading }) => {
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({
    contact_num: employee?.contact_num || '',
    alter_contact: employee?.alter_contact || '',
    address: employee?.address || ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onUpdate(formData);
    setEditMode(false);
  };

  const toggleEditMode = () => {
    setEditMode(!editMode);
    if (!editMode) {
      // Reset form data to current employee data when entering edit mode
      setFormData({
        contact_num: employee?.contact_num || '',
        alter_contact: employee?.alter_contact || '',
        address: employee?.address || ''
      });
    }
  };

  if (!employee) return null;

  return (
    <div className="profile-section editable-section">
      <div className="section-header">
        <h3>Contact Information</h3>
        <button
          className="edit-btn"
          onClick={toggleEditMode}
        >
          {editMode ? 'Cancel' : 'Edit'}
        </button>
      </div>
      
      {editMode ? (
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="contact_num">Contact Number:</label>
            <input
              type="text"
              id="contact_num"
              name="contact_num"
              value={formData.contact_num}
              onChange={handleInputChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="alter_contact">Alternative Contact:</label>
            <input
              type="text"
              id="alter_contact"
              name="alter_contact"
              value={formData.alter_contact}
              onChange={handleInputChange}
            />
          </div>

          <div className="form-group">
            <label htmlFor="address">Address:</label>
            <textarea
              id="address"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
            />
          </div>

          <button type="submit" className="profile-save-btn" disabled={loading}>
            {loading ? 'Saving...' : 'Save Changes'}
          </button>
        </form>
      ) : (
        <>
          <div className="info-row">
            <span className="info-label">Contact Number:</span>
            <span className="infos-value">{employee.contact_num}</span>
          </div>
          <div className="info-row">
            <span className="info-label">Alternative Contact:</span>
            <span className="infos-value">{employee.alter_contact}</span>
          </div>
          <div className="info-row">
            <span className="info-label">Address:</span>
            <span className="infos-value">{employee.address}</span>
          </div>
        </>
      )}
    </div>
  );
};

ContactInformation.propTypes = {
  employee: PropTypes.object,
  onUpdate: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default ContactInformation;